"use client";
import { MentorsCard } from "@/types/homepage";
import CourseCard from "../tools/course-finder/CourseCard";
import HomePageCourseCard from "./HomePageCourseCard";
import Link from "next/link";

const TopMatches = ({
  labe,
  content,
}: {
  content: MentorsCard[] | undefined;
  labe: string[] | undefined;
}) => {


  return (
    <div className="container max-w-[1400px] mx-auto pt-[48px] px-4 xxs:px-6 sm:px-[40px]">

      <div className="flex items-center justify-between gap-5 flex-col lg:flex-row">
        <div>
          <h2 className="ff_raleway text-[24px] sm:text-3xl md:text-4xl xl:text-5xl font-semibold leading-[1.25]">
            Check Your AI Mentor's Picks
          </h2>
          <p className="ff_poppins text-[12px] xxs:text-[14px] xs:text-[16px] sm:text-base md:text-lg lg:text-xl xl:text-2xl text-[#4B5563] font-semibold mt-1">
            Personalised based on your academic profile and preferences.
          </p>

        </div>
        <div className="hidden sm:flex  items-center justify-center">
          <Link
            href="/tools/course-finder?step=qualification"
            className="relative overflow-hidden inline-flex items-center justify-center bg-primary-gradient rounded-full py-[17px] px-8 text-white ff_poppins text-base text-center sm:text-lg md:text-xl xl:text-2xl font-semibold transition-all duration-300 ease-in-out hover:scale-105 focus:scale-105 shadow-[0px_5.06px_7.59px_-5.06px_#0000001A,0px_12.66px_18.99px_-3.8px_#0000001A] before:absolute before:top-[-55%] before:right-[calc(100%+20px)] before:z-0 before:h-[200%] before:w-[90px] before:rotate-[-80deg]"
          >
            <span className="relative z-10">
              Get Your Mentor’s Pick Now
            </span>
          </Link>

        </div>
      </div>
      <div className="mt-[25px] sm:mt-[48px] md:mt-[52px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[18px] md:gap-[24px] lg:gap-[30px] xl:gap-[36px]">
          {content &&
            content.map((item, index) => (
              <div
                key={index}
                className={`h-full ${!item.isTopMentorPick ? "hidden sm:block" : ""}`}
              >
                <HomePageCourseCard coursesCards={item} index={index} />
              </div>
            ))}
        </div>
        <div className="flex sm:hidden  items-center justify-center mt-6 sm:mt-7 md:mt-[32px]">
          <Link
            href="/tools/course-finder?step=qualification"
            className="relative overflow-hidden inline-flex items-center justify-center bg-primary-gradient rounded-full py-[17px] px-8 text-white ff_poppins text-[14px] text-center sm:text-lg md:text-xl xl:text-2xl font-semibold transition-all duration-300 ease-in-out hover:scale-105 focus:scale-105 shadow-[0px_5.06px_7.59px_-5.06px_#0000001A,0px_12.66px_18.99px_-3.8px_#0000001A] before:absolute before:top-[-55%] before:right-[calc(100%+20px)] before:z-0 before:h-[200%] before:w-[90px] before:rotate-[-80deg]"
          >
            <span className="relative z-10">
              Get Your Mentor’s Pick Now
            </span>
          </Link>
        </div>
      </div>

    </div>
  );
};
export default TopMatches;
